// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GYCr","question":"styles_question__2Vfbe","inputVisibleButton":"styles_inputVisibleButton__cX_0a","note":"styles_note__22ey-"};